<script setup></script>

<template>
  <div class="p-20 sm:p-30 wysiwyg">
    <p>
      A Travel Consultation is a pre-departure appointment beneficial for
      individuals planning various types of international travel, including
      holidays, business trips, cruises, emigration, and gap years. 
    </p>

    <p>Appointments typically last around 30 minutes.</p>

    <h4>When Should I Book?</h4>

    <p>
      Book 6–8 weeks before departure, or as soon as possible if your trip is
      sooner, to allow time for any recommended vaccines or treatments.
    </p>

    <h4>What Happens During the Consultation?</h4>

    <p>A healthcare professional will:</p>
    <ul>
      <li>
        Carry out a personalised risk assessment based on your health,
        destination, and trip type.
      </li>
      <li>
        Provide advice on staying well abroad, including food, water, and insect
        bite precautions.
      </li>
      <li>Explain what to do if you become unwell while travelling.</li>
      <li>Offer tailored guidance if you have existing medical conditions.</li>
      <li>Recommend any necessary vaccinations or antimalarials.</li>
    </ul>

    <p>
      Vaccines can often be given on the same day, depending on availability and
      your decision to proceed. To save time, please bring any records of
      previous vaccinations or travel clinic visits, if available.
    </p>

    <h4>What Happens After the Consultation?</h4>

    <p>
      Follow-up appointments will be arranged by the clinic if multiple doses
      are required.
    </p>
  </div>
</template>

<style scoped lang="scss"></style>
